import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.scss'

// 自动识别部署的子路径（如 /3dprint/）
;(function detectBasePath() {
  // 检查 URL 中是否包含 /3dprint/ 子路径
  const m = window.location.pathname.match(/^\/[^/]+(?=\/)/)
  const basePath = m ? m[0] : ''
  window.__BASE_PATH__ = basePath
})()

const app = createApp(App)

// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus, {
  locale: zhCn,
  size: 'default'
})
app.use(store)
app.use(router)

app.mount('#app')